import React, { useEffect, useRef, useState, useLayoutEffect } from 'react';

import "./categories.css";

export const Categories = ({data}) => {

    const ref = useRef();

    useLayoutEffect(() => {
        const refAnimate = ref.current.getBoundingClientRect().top;

        const onScroll = () => {
            if (refAnimate < window.scrollY) {
                ref.current.style.position = 'fixed';
                ref.current.style.top = 0;
                ref.current.style.left = 0;
                ref.current.style.right = 0;
                ref.current.style.margin = "0!important";
                ref.current.style.background = 'white';
                
            } else {
                ref.current.style.position = 'relative';
            }
        }
        window.addEventListener('scroll', onScroll);
        return  () => window.removeEventListener("scroll", onScroll);
    })

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        data.then(data => setCategories(data));
    }, [data]);

    const handleClick = (id) => {
        const target = document.getElementById(`category-${id}`);
        target.scrollIntoView({behavior: 'smooth'});
    }

    return (
        <div ref={ref} className="row pt-2 pb-2">
            <div className="categories-list">
                {categories.map(item => (
                    <div key={item.id} onClick={() => handleClick(item.id)} className="category-item">
                        <div className="category-content">
                            {item.name}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
